module.exports = __webpack_public_path__ + "images/stickers/pete-completed.213df9ec14509a7f0628.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-completed.png
// module id = rHZn
// module chunks = 1